<template>
  <div
    v-if="showTerm"
    style="
      display: grid;
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background-color: #0000007a;
      z-index: 99999;
      place-content: center;
      place-items: center;
    "
  >
    <main class="content">
      <div
        @scroll="onScroll"
        style="height: 90%; overflow: auto; text-align: left"
      >
        <h2 style="text-align: center"><strong>ADX利用規約</strong></h2>
        <p><br /></p>
        <p><strong>第1条（目的）</strong></p>
        <p>
          １．本利用規約（以下「本規約」といいます）は、株式会社アト（以下「当社」といいます）が提供するADXシステム（以下「本サービス」といいます）の利用に関する遵守事項などを定めています。本規約に同意いただけない場合、本サービスの利用はできません。
        </p>
        <p>
          ２．本サービスの利用を希望する方（以下「ユーザー」といいます）は、本規約のほか、当社がユーザーに表示し同意を求めた注意事項等を遵守し、本サービスを利用するものとします。
        </p>
        <p>
          ３．印刷、ポスティング、ポイント等に関し、当社所定の特約等がある場合、ユーザーは、これらの特約等も遵守し、本サービスを利用するものとします。
        </p>
        <p><br /></p>
        <p><strong>第2条（サービス内容）</strong></p>
        <p>
          １．本サービスは、インターネットを利用して印刷、ポスティング等当社所定のサービスの申込みを受け付けるサービスです。
        </p>
        <p>
          ２．本サービスは、日本国内において、当社所定の時間帯に限り、利用できます。本サービスが利用できない場合、当社に架電する方法など当社所定の方法により印刷・ポスティング等についてお問合せください。
        </p>
        <p>
          ３．当社は、本サービスの内容を追加、変更、廃止することができるものとします。当社がこの追加、変更、廃止を行う場合、第18条（規約の変更）に従うものとします。
        </p>
        <p>
          ４．本サービスの詳細な仕様は、当社のWebサイト上において別途定めるものとします。
        </p>
        <p>
          ５．ユーザーは、その費用と責任において、当社所定の仕様・動作環境を充たす端末を準備し、インターネットに接続できる環境を準備する必要があります。端末の不具合または端末の通信に係る不具合に起因し、ユーザーに生じた損害について、当社は責任を負いません。
        </p>
        <p><br /></p>
        <p><strong>第3条（利用登録）</strong></p>
        <p>
          １．ユーザーは、当社所定の方法で必要事項（以下「登録情報」といいます）を登録の上、利用登録の申請を行い、アカウントを開設する必要があります。
        </p>
        <p>
          ２．当社が前項の利用登録の申請を承諾した時に、当社とユーザーの間で、本規約を内容とする契約（以下「本契約」といいます）が成立するものとします。
        </p>
        <p>
          ３．当社は、利用登録の申請者が以下のいずれかに該当する場合、登録を拒否することがあります。
        </p>
        <p>(1)虚偽の情報を登録した場合</p>
        <p>
          (2)過去に本規約違反などで本サービスの登録取消等を受けたことがある場合
        </p>
        <p>(3)反社会的勢力又はその恐れがある者である場合</p>
        <p>(4)第三者になりすまして、利用登録を行おうとした場合</p>
        <p>
          (5)未成年者、成年被後見人、被保佐人又は被補助人で、法定代理人、後見人、保佐人又は補助人の同意等を得ていなかった場合
        </p>
        <p>(6)その他、当社が適切でないと判断した場合</p>
        <p>
          ４．第1項に基づく登録情報に誤り、相違、誤入力、不正確、過誤、誤認等があったとしても、当社の責めに帰すべき事由による場合を除き、当社は責任を負いません。
        </p>
        <p><br /></p>
        <p><strong>第4条（アカウント情報の管理）</strong></p>
        <p>
          １．ユーザーは、自己の責任において、アカウントに関する情報（ＩＤ、パスワードなどアカウントを利用するために必要な情報を意味し、以下「アカウント情報」といいます）を適切に管理及び保管する責任を負います。アカウント及びアカウント情報を第三者に譲渡等し、第三者に知らせ、または第三者に利用させることは認められません。
        </p>
        <p>
          ２．ユーザーは、本サービスを利用するためのパスワードを自ら登録・設定するものとします。パスワードは当社指定の文字数以上に限ります。また、ユーザーは、生年月日・電話番号・住所等の他人に推測されやすい文字・番号をパスワードに用いてはいけません。
        </p>
        <p>
          ３．アカウントのＩＤ、パスワード等が正しく入力された場合、当社は、ユーザーによる本サービスの利用であるとみなします。ユーザーは、この取扱いに異議を述べないものとします。
        </p>
        <p>
          ４．ユーザーは、当社所定の方法によりパスワードを変更することができます。また、ユーザーがパスワードを失念した場合、ユーザー自ら、当社所定の方法によりパスワードの再登録・再設定を行ってください。
        </p>
        <p>
          ５．ユーザーによるアカウント情報の管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任はユーザーが負うものとし、当社はこれについて責任を負いません。但し、ユーザーが消費者である場合において、当社に帰責事由があるときには、この限りではありません。
        </p>
        <p>
          ６．ユーザーの過失によってアカウント情報が不正に利用されたこと等により当社に損害が生じた場合、ユーザーは当社に対し当該損害を賠償する責任を負うものとします。
        </p>
        <p><br /></p>
        <p><strong>第5条（個人情報の取扱い</strong>）</p>
        <p>
          当社は、ユーザーの個人情報を、当社所定の「プライバシーポリシー」に基づき、適切に取り扱うものとします。
        </p>
        <p>当社のプライバシーポリシーは、下記のとおりです。</p>
        <p>
          <a
            href="https://www.ato-co.jp/privacy/"
            rel="noopener noreferrer"
            target="_blank"
            >https://www.ato-co.jp/privacy/</a
          >
        </p>
        <p><br /></p>
        <p><strong>第6条（注文および支払い）</strong></p>
        <p>
          １．ユーザーは、本サービスを通じて印刷・ポスティングなど当社所定のサービスについて注文を行うものとし、当社はその注文を受け付けます。当社が、当社所定の方法で「ユーザーの注文を承諾する」旨のご連絡を行った時点で、当社とユーザーの間に、印刷・ポスティング等当社所定のサービスに係る個別契約が成立するものとします。個別契約の注文内容、支払金額や支払い方法などは、本サービスに係る当社のWebサイト並びにユーザーに当社がお送りする注文承諾に係る電子メールに記載のとおりとします。
        </p>
        <p>
          ２．次のいずれかに掲げる場合には、当社は印刷・ポスティング等の申込みを拒絶することができるものとし、また個別契約が成立した場合であっても、当社はこれを取り消すことができるものとします。
        </p>
        <p>
          (1)注文内容が第三者の知的財産権、肖像権、プライバシー権、名誉権その他の権利を侵害すると当社が判断する場合
        </p>
        <p>
          (2)注文内容が法令又は公序良俗に反するものであると当社が判断する場合
        </p>
        <p>(3)注文内容が当社所定の配布基準等に違反する場合</p>
        <p>(4)その他、個別契約の履行、継続が不適切であると当社が判断する場合</p>
        <p>
          ３．ユーザーによる当社への支払いは、クレジットカード決済、コンビニ決済、ペイジー決済、にて行います。請求書払いについては、株式会社ネットプロテクションズの審査が必要です
          。
        </p>
        <p>
          ４．本サービスを通じて成立した個別契約について、当社が書面により承諾した場合を除き、ユーザーは変更・解約できません。
        </p>
        <p><br /></p>
        <p><strong>第7条（禁止事項）</strong></p>
        <p>
          ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。
        </p>
        <p>
          (1)法令または公序良俗に反する行為、違法または不正な目的をもって本サービスを利用する行為
        </p>
        <p>
          (2)法令上、禁止されている情報を登録する行為または虚偽の情報を登録する行為
        </p>
        <p>(3)不正アクセス行為、当社または第三者の知的財産権を侵害する行為</p>
        <p>(4)当社またはユーザーが所属する業界団体の内部規則に違反する行為</p>
        <p>(5)本サービスの運営、維持を妨げるおそれのある行為</p>
        <p>
          (6)本サービスを通じて入手した情報を、複製、販売、出版、その他私的利用の範囲を超えて使用する行為
        </p>
        <p>(7)当社その他本サービスの関係者に迷惑、不利益を与える行為</p>
        <p>
          (8)第三者にアカウント及び本サービスを利用させる行為、または他人になりすまして本サービスを利用する行為
        </p>
        <p>
          (9)アカウントまたはアカウント情報を第三者に開示・譲渡・売買等する行為
        </p>
        <p>(10)その他、当社が不適切と判断する行為</p>
        <p><br /></p>
        <p><strong>第8条（データの取り扱い）</strong></p>
        <p>
          １．ユーザーが本サービスに提供するデータは、ユーザー自身がその著作権その他の知的財産権を保有または正当に使用する権利を有するものに限ります。
        </p>
        <p>
          ２．当社は、ユーザーから提供されたデータを本サービスの提供のため及び第５条に定めるプライバシーポリシーに定める利用目的の達成のために必要な範囲内で使用します。
        </p>
        <p><br /></p>
        <p><strong>第９条（秘密保持）</strong></p>
        <p>
          １．当社及びユーザーは、本サービスに関し、善良なる管理者の注意をもって、相手方の技術上又は営業上その他業務上の一切の情報（以下、「秘密情報」という。）について、本契約の有効期間中はもとより、本契約終了後もその秘密を守り、これを第三者（弁護士、会計士又は税理士等法律に基づき守秘義務を負う者を除く。以下、本条において同じ。）に漏洩してはならないものとします。ただし、次に定めるもの（個人情報については適用しない。）については、秘密保持義務を負いません。
        </p>
        <p>①相手方から開示される前に既に公知の情報</p>
        <p>②相手方から開示された後に自らの責によらず公知となった情報</p>
        <p>③相手方から開示される前に既に知得していた情報</p>
        <p>
          ④相手方に対し秘密保持義務を負わない
          正当な権限を有する第三者から、秘密保持義務を負うことなく適法に開示された情報
        </p>
        <p>⑤相手方から開示された情報に触れることなく独自に創出した情報</p>
        <p>
          ２．前項の規定にかかわらず、当社又はユーザーは、秘密情報のうち法令又は裁判所の命令により開示することが義務付けられた情報を、当該法令又は命令に定める開示先又は裁判所に対して開示することができるものとします。
        </p>
        <p>
          ３．当社及びユーザーは、必要な範囲を超えて秘密情報を複写もしくは複製又は第三者に提供してはならないものとします。なお、当該複写もしくは複製物も、秘密情報として取り扱われるものとします。
        </p>
        <p><br /></p>
        <p><strong>第10条（委託）</strong></p>
        <p>
          当社は、本サービスの提供に関し、必要に応じ、第三者に委託を行うことができるものとします。
        </p>
        <p><br /></p>
        <p><strong>第11条（免責事項・無保証）</strong></p>
        <p>
          １．当社は、本サービスについて、次に掲げる損害について責任を負いません。
        </p>
        <p>
          (1)当社は、本サービスの利用によって生じたユーザーの損害について、責任を負いません。ただし、当社に故意または重過失がある場合はこの限りではありません。
        </p>
        <p>
          (2)当社は、本サービスの中断、中止、変更により生じたユーザーの損害について、責任を負いません。
        </p>
        <p>
          (3)不可抗力による本サービスの提供に遅延、不能等があった場合、当社は、これによってユーザーに生じた損害について、責任を負いません。
        </p>
        <p>
          (4)ユーザーが本規約に違反した場合、またはユーザーの端末の仕様・動作環境が当社所定のものを満たさなかった場合、またはユーザー端末が正常に稼動しなかったことによりユーザーに生じた損害について、当社は責任を負いません。
        </p>
        <p>
          (5)
          当社が相当の安全策を講じたにもかかわらず、本サービスの提供に係るシステムに障害が生じたことによるユーザーの損害について、当社は責任を負いません。
        </p>
        <p>
          (6)
          当社が相当の安全対策を講じたにもかかわらず、システムの障害により、ユーザーの登録情報等が消失、変容したためにユーザーに生じた損害について、当社は責任を負いません。
        </p>
        <p>
          ２．当社は、ユーザーに対し、(ｱ)
          本サービスがユーザーの特定の目的に適合すること、(ｲ)
          本サービスが期待する機能・正確性・有用性・完全性を有すること、(ｳ)
          ユーザーによる本サービスの利用が第三者の知的財産権を侵害しないこと、(ｴ)
          本サービスが将来にわたり継続的に利用できること、(ｵ)
          本サービスに不具合が生じないこと、(ｶ) 本サービスのサービスレベル、(ｷ)
          本サービスのセキュリティの完全性等について、明示又は黙示を問わず、いかなる保証も行わず、本サービスについて現状有姿にてユーザーに提供します。
        </p>
        <p><br /></p>
        <p><strong>第12条（ユーザーの損害賠償責任）</strong></p>
        <p>
          １．ユーザーは、本サービスの利用に関連して当社に損害を与えた場合、当社に対し、その損害を賠償するものとします。
        </p>
        <p>
          ２．ユーザーが、本サービスに関連して、第三者からクレームを受け、又はそれらの者との間で紛争が生じた場合には、直ちにその内容を当社に通知するとともに、ユーザーの費用と責任において当該クレーム、又は紛争を処理し、その結果を当社に報告するものとします。
        </p>
        <p>
          ３．ユーザーによる本サービスの利用に関連して、当社が、第三者から権利侵害、その他の理由により何らかの請求を受けた場合は、ユーザーはそれに基づき当社が第三者に支払を余儀なくされた金額を賠償しなければなりません。
        </p>
        <p><br /></p>
        <p><strong>第13条（当社の損害賠償責任の制限）</strong></p>
        <p>
          １．本サービスの利用に関してユーザーに生じた損害についての当社の責任は、当社の故意または重過失による場合で、かつ直接の通常損害の範囲に限られます。いかなる場合においても、当社は、ユーザーの特別損害、逸失利益および間接損害について責任を負いません。
        </p>
        <p>
          ２．前項に従い当社が損害賠償責任を負う場合においても、その責任は、当該損害の原因となった個別契約についてユーザーが当社に支払った又は支払うべき対価の額を上限とします。
        </p>
        <p><br /></p>
        <p><strong>第14条（本サービスの変更、中断、終了）</strong></p>
        <p>
          １．当社は、事業上の理由、システムの過負荷・システムの不具合・メンテナンス・法令の制定改廃・天災地変・停電・通信障害・不正アクセス、その他の事由により、事前の予告なくして、本サービスをいつでも変更、中断、終了することができます。本サービスが利用できない場合、当社に架電する方法などにより、印刷・ポスティング等についてお問合せください。
        </p>
        <p>
          ２．当社は、前項の変更、中断、終了によってユーザーに生じたいかなる損害について、一切責任を負いません。
        </p>
        <p><br /></p>
        <p><strong>第15条（登録情報の変更）</strong></p>
        <p>
          １．ユーザーは、当社所定の方法により、当社所定の範囲内で登録情報を変更することができます。
        </p>
        <p>
          ２．登録情報に変更が生じた場合、ユーザーは、前項の定めに従い、速やかにこれを登録するものとします。この変更の登録がなされるまでの間、当社は、登録情報に従い本サービスを提供するものとし、ユーザーはこれに異議を述べないものとします。
        </p>
        <p>
          ３．ユーザーの登録情報に誤り、相違、誤入力、不正確、過誤、誤認等があったとしても、当社の責めに帰すべき事由による場合を除き、当社は責任を負いません。
        </p>
        <p><br /></p>
        <p><strong>第16条（登録抹消等）</strong></p>
        <p>
          当社は、ユーザーが以下の各号のいずれかに該当し又は該当すると当社が判断した場合は、事前に通知することなく、ユーザーについて本サービスの利用を一時的に停止し又はユーザーの登録情報およびアカウントを抹消して本契約を解除することができます。
        </p>
        <p>(1)本規約のいずれかの条項に違反した場合</p>
        <p>
          (2)支払停止若しくは支払不能となり、又は、破産、民事再生手続き開始、会社更生手続開始、特別清算手続開始もしくはこれらに類する手続きの開始の申立てがあった場合
        </p>
        <p>
          (3)自ら振出し、もしくは引受けた手形または小切手につき、不渡りの処分を受けた場合
        </p>
        <p>(4)差押、仮差押、仮処分、強制執行または競売の申立てがあった場合</p>
        <p>(5)租税公課を滞納し、その保全差押を受けた場合</p>
        <p>(6)解散または営業停止状態となった場合</p>
        <p>(7)24ヶ月以上ユーザーによる本サービスの利用がない場合</p>
        <p>(8)当社からの問い合わせに対して、30日間以上応答がない場合</p>
        <p>
          (9)その他、当社がユーザーによるサービスの利用を適当でないと判断した場合
        </p>
        <p><br /></p>
        <p><strong>第15条（連絡、通知）</strong></p>
        <p>
          当社からユーザーに対する連絡又は通知は、登録情報に含まれるメールアドレスに電子メールを送る方法その他当社の定める方法によって行うものとします。当社が登録情報に含まれるメールアドレスその他の連絡先に対して連絡又は通知を発信した場合、ユーザーは当該連絡又は通知を受領したものとみなします。
        </p>
        <p><br /></p>
        <p><strong>第16条（反社会的勢力の排除）</strong></p>
        <p>
          １．ユーザーは、現時点および本契約の有効期間中、将来にわたって、ユーザーが以下の各号のいずれにも該当しないことを表明し、または確約するものとします。
        </p>
        <p>
          (1)
          暴力団、暴力団員、暴力団でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他これらに準ずる者（本規約において、総称して「反社会的勢力」といいます。）であること、または反社会的勢力であったこと
        </p>
        <p>(2) 反社会的勢力が経営を支配していること</p>
        <p>
          (3)
          代表者、責任者または経営に実質的に関与している者が反社会的勢力であること
        </p>
        <p>
          (4)
          自己または第三者の不正の利益を図る目的をもってするなど反社会的勢力を利用していると認められる関係を有すること
        </p>
        <p>
          (5)
          反社会的勢力に対して資金等を提供し、または便宜を図るなど反社会的勢力に利益を供与していると認められる関係を有すること
        </p>
        <p>
          (6)
          反社会的勢力と密接に交際をするなど社会的に非難されるべき関係を有すること
        </p>
        <p>(7) 暴力的または法的な責任を超えた不当な要求行為を行うこと</p>
        <p>
          (8) 取引に関して脅迫的な言動をし、または暴力を用いる行為を行うこと
        </p>
        <p>
          (9)
          風説を流布し、または偽計もしくは威力を用いて、当社の信用を毀損し、または当社の業務を妨害する行為を行うこと
        </p>
        <p>
          ２．ユーザーが前項の表明または確約のいずれかに違反した場合、当社は通知その他の手続を要しないで、本契約及び個別契約を解除することができ、解除により生じた損害の賠償をユーザーに請求できるものとする。また、かかる解除によりユーザーに生じた損害について、当社は賠償義務を負わないものとします。
        </p>
        <p><br /></p>
        <p><strong>第17条（有効期間）</strong></p>
        <p>
          本契約は、本規約の定めに従い成立した日から、本規約の定めに従い終了するまで、ユーザーのアカウントが有効に登録されている限り、有効に存続するものとします。
        </p>
        <p><br /></p>
        <p><strong>第18条（規約の変更）</strong></p>
        <p>
          １．当社は、必要と判断した場合には、当社のWebサイトに変更内容及び変更の効力発生日を掲載する方法その他当社所定の方法で変更内容をあらかじめ周知することにより、本規約を変更することができます。
        </p>
        <p>２．変更後の本規約は、変更の効力発生日に効力を生じます。</p>
        <p><br /></p>
        <p><strong>第19条（準拠法および裁判管轄）</strong></p>
        <p>
          本規約は日本法に準拠し、日本語をもって解釈されます。また、本サービスに関連して生じた紛争については、東京地方裁判所を第一審の専属的管轄裁判所とします。
        </p>
        <p><br /></p>
        <p><strong>第20条（権利義務の譲渡等の禁止）</strong></p>
        <p>
          ユーザーは、本規約に基づく権利または義務を当社の事前の書面による承諾を得ることなく第三者に譲渡することはできません。
        </p>
        <p><br /></p>
        <p><strong>第21条（分離可能性）</strong></p>
        <p>
          本規約の規定の一部が法令又は裁判所により違法、無効又は不能であるとされた場合においても、本規約のその他の規定は有効に存続します。
        </p>
        <p><br /></p>

        <h2 style="text-align: center">
          <strong>ポイントに関する特約</strong>
        </h2>
        <p><br /></p>
        <p><strong>第1条　ポイントの取得</strong></p>
        <p>
          ユーザーは、当社が定める要件を満たす場合に限り、当社が定める手続きに従い、当社が定める基準により、当社が定める期間経過後に、本サービス内でのみ使用が可能なポイントを取得することができます。
        </p>
        <p>
          本規約に違反をしているおそれがあると当社が判断した場合、偽りその他不適正な手段でポイントを取得しようと試みた場合など、ユーザーがポイントを取得することが適切でないと当社が認める事由が生じた場合は、当社は、ユーザーに対し、事前に通知することなく、ポイントを発行しないことができます。
        </p>
        <p><br /></p>
        <p><strong>第2条　ポイントの管理</strong></p>
        <p>
          ユーザーは、商品注文時のカート内にてポイントの残高を確認することができます。
        </p>
        <p>
          ユーザーは、ポイントの残高に疑義がある場合は、直ちに当社にその旨連絡をするものとします。当社とユーザーの間にポイントの残高について紛議が生じた場合、当社の帳簿の定める内容をもってユーザーのポイントの残高を確定するものとします。
        </p>
        <p><br /></p>
        <p><strong>第3条　ポイントの使用</strong></p>
        <p>
          ユーザーは、当社があらかじめポイントの使用を認めた場合に限り、ポイントを使用することで、本サービスの代金の全部又は一部の支払いに代えることができます。ユーザーがポイントを使用する場合には、本サービス内にてお支払方法の登録時にポイントの使用有無を選択することでポイントの使用が可能となります。１ポイントの円換算は、当社が別に定めるとおりとします。
        </p>
        <p>
          ポイントは、ポイント使用時において、当社が定める条件を満たしていれば、本サービスの代金の支払いに代えることができる可能性を表象しているものであり、ポイントの取得によって、ユーザーと当社との間に具体的な権利義務が発生するわけではありません。ポイントは、将来的に変更・廃止される可能性があり、ポイント取得時に想定されていたポイントの使用について、当社は保証しません。
        </p>
        <p>
          ポイントの管理及び使用は、ユーザーの責任において行われるものとします。ポイントの使用について、いかなる理由でも、使用後のキャンセルやポイントの再発行等の措置を取ることはできません。ユーザー以外の第三者により不正使用され、そのためにユーザーのポイントが消失した場合であっても、ポイントの再発行はできません。
        </p>
        <p>
          ユーザーは、他のユーザーとポイントを共有、合算してポイントを使用することはできません。また、他のユーザーにポイントを移転、譲渡等することもできません。
        </p>
        <p><br /></p>
        <p><strong>第4条　ポイントの取消・消失等</strong></p>
        <p>
          当社は、ユーザーがポイントを取得した後、ユーザーがポイントを取得することが適切でないと当社が認める事由が生じた場合は、事前に通知することなく、発行済のポイントを取り消すことができます。
        </p>
        <p>
          事由の如何を問わず、ユーザーがアカウントを失い、本契約が終了した場合、当社が本サービスを終了・廃止した場合、その時点でユーザーが保有していたポイントは全て消失し、履歴情報も抹消されます。
        </p>
        <p>
          当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
        </p>
        <p>
          当社は、事前に予告することなく、ポイントに係る取扱いを変更する場合があり、ユーザーは異議を述べないものとします。
        </p>
        <p>
          ポイントの有効期限は1年間とし、ユーザーがポイントを取得した日から1年後の応当日までにポイントを利用しなかった場合には、ポイントは自動的に消滅します。
        </p>
        <p><br /></p>
        <p><strong>第5条　ポイント制度の変更</strong></p>
        <p>
          当社は、ポイント制度を、必要に応じて随時、変更することができます。変更の手続等については本規約第18条の定めるところによります。
        </p>
        <p><br /></p>
        <!-- <div class="section">
          <p class="font-bold">ポスティング</p>

          <p>配布エリア、部数、スケジュールについて</p>
          <p style="color: red">
            エリア選択時に表示される配布部数は、当サービス独自の配布部数を示しており、選択エリアの全世帯への配布を保証するものではありません。
          </p>
          <p>
            町丁目ごとの配布部数は、概算のため実際とは異なる可能性がございます。
          </p>
          <p>
            配布先居住者のご意向による配布拒否、区画整理、住宅事情の変化、配布員確保、交通事情、天災・天候不良等の諸事情により選択エリア内の実配布数が配布見込数を下回った場合又は配布出来ないエリアが生じた場合、残数は、選択エリア近隣に配布されます。
          </p>
          <p>
            単独の配布ではなく他社広告物と併せて配布を行います。情報誌への挟み込み、丁合を行う場合があります
          </p>
          <p>
            選択された配布完了希望日どおりの配布をお約束することはできかねます。実際の完了予定日は、入稿データの審査後にご連絡致します。
          </p>
        </div> -->

        <!-- <div class="section">
          <p class="font-bold">新聞折込</p>
          <p>
            選択された配布完了希望日どおりの配布をお約束することはできかねます。実際の完了予定日は、入稿データの審査後にご連絡致します。
          </p>
          <p>
            配布先居住者のご意向による配布拒否、区画整理、住宅事情の変化、配布員確保、交通事情、天災・天候不良等の諸事情により選択エリア内の実配布数が配布見込数を下回った場合又は配布出来ないエリアが生じた場合、残数は、選択エリア近隣に配布されます。
          </p>
          <p>
            単独の配布ではなく他社広告物と併せて配布を行います。情報誌への挟み込み、丁合を行う場合があります。
          </p>
          <p>
            選択された配布完了希望日どおりの配布をお約束することはできかねます。実際の完了予定日は、入稿データの審査後にご連絡致します。
          </p>
        </div>

        <div class="section">
          <p class="font-bold">アプリ配信</p>
          <p>
            選択された配布完了希望日どおりの配布をお約束することはできかねます。実際の完了予定日は、入稿データの審査後にご連絡致します。
          </p>
          <p>
            配布先居住者のご意向による配布拒否、区画整理、住宅事情の変化、配布員確保、交通事情、天災・天候不良等の諸事情により選択エリア内の実配布数が配布見込数を下回った場合又は配布出来ないエリアが生じた場合、残数は、選択エリア近隣に配布されます。
          </p>
        </div> -->
      </div>
      <div class="footers">
        <button :disabled="disableOk" @click="termOk" class="button">承諾する</button>
      </div>
    </main>
  </div>
  <div id="head_top" class="body-header login">
    <!-- When Already Login -->
    <header v-if="!authStore.state.isGuest" id="gHeader" class="gHeader">
      <div class="branding">
        <a @click="onClickMenu"
          ><img
            src="../assets/img/logo01.png"
            alt="ADK"
            width="383"
            height="116"
        /></a>
      </div>
      <div id="gNav" class="gNav" :class="isMenuBar ? 'transform-menu' : ''">
        <nav class="navigation">
          <div class="service">
            <a @click="onClickMyAccount" class="button">
              <!-- <div class="name">株式会社アト 奈須田さん</div> -->
              <div class="name">
                {{ myAccount().company_name }}
                {{
                  myAccount().user_name
                    ? myAccount().user_name.split(" ")[0]
                    : "ゲストさん"
                }}
                さん
              </div>
              <div class="label">アカウントサービス</div>
            </a>
            <div class="menu-ghost" >
            </div>
            <div class="menu">
              <ul>
                <li>
                  <a @click="onClickMyAccount">マイアカウント確認・変更</a>
                </li>
                <li
                  v-if="
                    authStore.state.orgType === 0 ||
                    (authStore.getters.authLevel >= 1 &&
                      authStore.state.orgType !== 0)
                  "
                >
                  <a @click="onClickMyAccountMannage">アカウント追加・削除</a>
                </li>
                <li><a @click="onClickLogout">ログアウト</a></li>
              </ul>
            </div>
          </div>
          <ul class="list">
            <li>
              <a @click="onClickMap" class="map"><i></i>地図から注文する</a>
            </li>
            <li>
              <a @click="onClickMenu" class="status"
                ><i></i>注文・注文状況の確認</a
              >
            </li>
            <li><a @click="onClickCart" class="cart"></a></li>
          </ul>

          <div
            class="spMenu"
            :class="isMenuBar ? 'show-navbar' : 'hide-navbar'"
          >
            <ul class="toc">
              <li>
                <a href="/map?path=posting" class="map">地図から注文する</a>
              </li>
              <li>
                <a href="/" class="status"><i></i>注文状況の確認</a>
              </li>
              <li>
                <a href="/myAccount" class="myacount">マイアカウント</a>
              </li>
              <li>
                <a href="/term" class="guide">ご利用ガイド</a>
              </li>
              <li>
                <a href="/faq" class="faq">よくあるご質問</a>
              </li>
              <li>
                <a
                  href="https://www.ato-co.jp/contact/"
                  target="_blank"
                  class="contact"
                  >お問い合わせ</a
                >
              </li>
              <li><a href="/" class="all">すべての管理メニューへ</a></li>
            </ul>
            <ul class="member">
              <li>
                <a @click="onClickRegister()" class="entry">新規会員登録</a>
              </li>
              <li>
                <a @click="onClickLogin()" class="btn--01 login">ログアウト</a>
              </li>
            </ul>
          </div>
        </nav>
        <label class="btn btn--menu menu-phone" aria-label="MENU">
          <input type="checkbox" v-model="isMenuBar" />
          <div class="bar"></div>
        </label>
      </div>
    </header>

    <!-- When didnt Login -->

    <header v-else id="gHeader" class="gHeader">
      <div class="branding">
        <a @click="onClickMenu"
          ><img
            src="../assets/imgs/logo01.png"
            alt="ADK"
            width="383"
            height="116"
        /></a>
      </div>
      <div id="gNav" class="gNav" :class="isMenuBar ? 'transform-menu' : ''">
        <!-- <div v-if="isRegisterMessage && $route.fullPath === '/map?path=posting'" style="position: absolute; top: 55px; right: 175px; height: 50px; width: 50px; background-color: #85a02f; rotate: 45deg; z-index: 98;"></div> -->
        <!-- <div v-if="isRegisterMessage && $route.fullPath === '/map?path=posting'" class="serif-text" style="position: absolute; top: 60px; right: 100px; height: 200px; width: 400px; background-color: white; border: 2px #85a02f solid; z-index: 99;">
          <div class="font-popup-apartment" style="position: relative; display: flex; flex-direction: column; justify-content: start; align-items: start; font-size: 14px; color: black; padding: 20px;">
            <div class="flex-popup-apartment">
              <h4 class="font-red-popup" style="margin-bottom: 12px; font-weight: 700;">◎会員登録無料！</h4>
              <h5 style="font-weight: 400;">新規会員登録で</h5>
              <h5 style="font-weight: 700;">①ターゲットのセグメント機能</h5>
              <h5 style="font-weight: 700;">②一括見積</h5>
              <h5 style="font-weight: 700;">③各種媒体発注</h5>
              <h5 style="font-weight: 400; margin-bottom: 8px;">が利用できるようになります！</h5>
              <h5 class="font-red-popup" style="text-decoration: underline; font-weight: 700;">登録は簡単・1分でできます！</h5>
            </div>

            <div style="position: absolute; bottom: 20px; right: 8px; width: 140px;">
              <button @click="onClickToRegisterPage" class="red-background-popup" style="width: 90%; height: 110px; border-radius: 0px; color: white; font-weight: 400; padding-left: 8px; padding-right: 8px;">新規会員登録はこちらから</button>
            </div>
            <div style="position: absolute; top: 4px; right: 24px; width: 10px;">
              <button @click="onClickCloseNeedRegister" style="width: 24px; height: 24px; border-radius: 4px; color: white; background-color:black; font-weight: 700; font-size: 12px;">X</button>
            </div>
          </div>
        </div> -->
        <nav class="navigation">
          <ul class="list">
            <li>
              <a @click="onClickTerm" class="guide"><i></i>ご利用ガイド</a>
            </li>
            <li>
              <a @click="onClickFaq" class="faq"><i></i>よくあるご質問</a>
            </li>
            <li>
              <a @click="onClickMap" class="map"><i></i>地図から注文する</a>
            </li>
            <li>
              <a @click="onClickRegister" class="entry"><i></i>新規会員登録</a>
            </li>
            <li>
              <a @click="onClickLogin" class="btn--01 login">ログイン</a>
            </li>
          </ul>

          <div
            class="spMenu"
            :class="isMenuBar ? 'show-navbar' : 'hide-navbar'"
          >
            <ul class="toc">
              <li>
                <a href="/map?path=posting" class="map">地図から注文する</a>
              </li>
              <li>
                <a href="/term" class="guide">ご利用ガイド</a>
              </li>
              <li>
                <a href="/faq" class="faq">よくあるご質問</a>
              </li>
              <li>
                <a
                  href="https://www.ato-co.jp/contact/"
                  target="_blank"
                  class="contact"
                  >お問い合わせ</a
                >
              </li>
            </ul>
            <ul class="member">
              <li>
                <a @click="onClickRegister" class="entry">新規会員登録</a>
              </li>
              <li>
                <a @click="onClickLogin" class="btn--01 login">ログイン</a>
              </li>
            </ul>
          </div>
        </nav>
        <label class="btn btn--menu menu-phone" aria-label="MENU">
          <input type="checkbox" v-model="isMenuBar" />
          <div class="bar"></div>
        </label>
      </div>
    </header>
  </div>
</template>

<script>
import { authStore } from "../store/auth-store";
import { accountStore } from "../store/account-store";
import { createDeviceDetector } from "next-vue-device-detector";
import backendApi from "@/apis/backend-api";
import { mapModeStore } from "../store/map-mode-store";
import { mapDomain } from "../utils/mapDomain";
import { ref } from "vue";
import { event } from "jquery";

const device = createDeviceDetector();
export default {
  name: "Header",
  props: {
    msg: String,
    onTermAcceptFunc: {
      type: Function,
      default: () => {},
    },
    showTerm: {
      type: Boolean,
      default: false
    },
    fromRegister: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      accountStore,
      authStore,
      device,
      sidemenu: ref(false),
      termModal: false,
      disableOk: true,
      isMenuBar: false,
      isRegisterMessage: true,
    };
  },
  async created() {
    const myAccountResponse = await backendApi.myAccountInfo();
    if (myAccountResponse.result == "success") {
      this.accountStore.commit("updateMyAccount", myAccountResponse.value);
    }
  },
  mounted() {
    this.termModal = this.authStore.state.first_login;
    // console.log(this.termModal)
  },
  mounted() {
    jQuery(($) => {
      "use strict";

      const $body = $("body-header");

      /* ---------- intersectionObserver ---------- */

      let isftrLogoShowed = false;

      const intersectionObserver = new IntersectionObserver(
        (entry) => {
          for (let i = 0; i < entry.length; ++i) {
            const $target = $(entry[i].target);
            const data = $target.attr("data-scroll");

            switch (data) {
              case "hero":
                if (entry[i].isIntersecting) {
                  $body.removeClass("turnHeader");
                } else {
                  $body.addClass("turnHeader");
                }
                break;

                break;
              case "at50":
                if (
                  entry[i].isIntersecting &&
                  entry[i].intersectionRatio >= 0.5
                ) {
                  $target.addClass("scrollIn");
                }
                break;
              default:
                if (entry[i].isIntersecting) {
                  $target.addClass("scrollIn");
                }
            }
          }
        },
        {
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        }
      );

      const intersectionObserverTargets =
        document.querySelectorAll(".watchScroll");

      intersectionObserverTargets.forEach((target) => {
        intersectionObserver.observe(target);
      });

      /* ---------- mv ---------- */

      const $mv = $(".hero");

      if ($mv.length > 0) {
        const $mvMovie = $(".movie", $mv);
        const $mvlogo = $(".logo img", $mv);
        const video = document.getElementById("video");

        const mediaQueryList = window.matchMedia("(max-width: 750px)");

        const handleMediaChange = (ev) => {
          if (ev.matches) {
            video.setAttribute("src", "../assets/img/mv_sp.mp4");
          }
        };

        handleMediaChange(mediaQueryList);

        video.play();

        video.addEventListener("ended", () => {
          $mvMovie.fadeOut(800, () => {
            $mvMovie.remove();
            $mv.addClass("ready");
            $mvlogo.attr(
              "src",
              "../assets/imgs/logo_a.png?" + new Date().getTime()
            );
          });
        });
      }

      /* ---------- misc ---------- */

      const $gNavServiceMenu = $(".gNav .service .menu");

      const $menuGhost = $(".gNav .service .menu-ghost")
      $menuGhost.height($gNavServiceMenu.height())
      $menuGhost.width($gNavServiceMenu.width())

      $(".gNav .service")
        .on("mouseover", () => {
          $gNavServiceMenu.slideDown();
          $menuGhost.show()
        })
        .on("mouseleave", () => {
          $gNavServiceMenu.slideUp();
          $menuGhost.hide()
        });

      $(".num .counter").each((index, el) => {
        const $target = $(el);
        const step = parseInt($target.data("step"));
        let number = $target.find(".row").text();
        let text = "";
        number = number.replace(/,/, "");
        number = parseInt(number);

        for (let i = 0; i < 49; i++) {
          number = number - step;
          text = number.toLocaleString();
          console.log(text);
          $("<div>")
            .addClass("row")
            .text(text)
            .prependTo($target.find(".inner"));
        }
      });
    });

    this.addEventPostMessage();
  },
  methods: {
    addEventPostMessage() {
      window.addEventListener("message", (event) =>
        this.postMessageEventPopup(event)
        // console.log(event)
      );
    },
    postMessageEventPopup(event) {
      // Always check the origin of the message for security purposes
      if (event.origin === mapDomain) {
        // Adjust to the iframe's origin
        const data = event.data;
        // console.log(data)
        if (data.action === "changeIsGuest" && data.type === 'save') {
          this.isRegisterMessage = true
        }
      }
    },
    myAccount() {
      return this.accountStore.getters.myAccount;
    },
    onScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      // console.table(scrollTop, offsetHeight, scrollHeight);

      if (scrollTop + offsetHeight >= scrollHeight - 3) {
        this.disableOk = false;
      } else {
        this.disableOk = true;
      }
    },
    myAccount() {
      return this.accountStore.getters.myAccount;
    },
    termOk() {
      if(this.fromRegister) {
        this.onTermAcceptFunc()
      } else {
        this.termModal = false;
        this.authStore.commit("updateFirstLogin", false);
      }
    },
    onClickLogout() {
      mapModeStore.commit("clearMode");
      authStore.commit("clearToken");
      location.href = "/map";
    },
    onClickLogin() {
      authStore.commit("clearToken");
      this.$router.push("/login");
    },
    onClickRegister() {
      authStore.commit("clearToken");
      this.$router.push("/init_register");
    },
    onClickMap() {
      // location.href = "/";
      this.$router.push("/map");
    },
    onClickCart() {
      // location.href = "/";
      this.$router.push("/cart");
    },
    onClickMenu() {
      this.$router.push("/");
    },
    onClickTerm() {
      this.$router.push("/term");
    },
    onClickFaq() {
      this.$router.push("/faq");
    },
    url: function (item) {
      console.log(item);
    },
    getBreadcrumb() {
      if (this.$route.path == "/map") {
        return " / マップ";
      } else if (this.$route.path == "/orikomi_map") {
        return " / オリコミマップ";
      } else if (this.$route.path == "/") {
        return " ";
      } else if (this.$route.path == "/cart") {
        return " / カート";
      } else if (this.$route.path == "/faq") {
        return " / よくある質問";
      } else if (this.$route.path == "/term") {
        return " / ご利用ガイド";
      } else if (this.$route.path == "/orders") {
        return " / ポスティング注文リスト";
      } else if (this.$route.path == "/orders_orikomi") {
        return " / オリコミ注文リスト";
      } else if (this.$route.path == "/orders_geenie") {
        return " / DSP配信注文リスト";
      } else if (this.$route.path.includes("/order_geenie")) {
        return "<span> / <a href='/orders_geenie' style='text-decoration:none;color:#fff;'>DSP配信注文リスト</a>/ 注文詳細</span> ";
      } else if (this.$route.path.includes("/order/")) {
        return "<span> / <a href='/orders' style='text-decoration:none;color:#fff;'>ポスティング注文リスト</a>/ 注文詳細</span>";
      } else if (this.$route.path.includes("/order_orikomi/")) {
        return "<span> / <a href='/orders_orikomi' style='text-decoration:none;color:#fff;'>オリコミ注文リスト</a>/ 注文詳細</span>";
      } else if (this.$route.path == "/accounts/manage") {
        return " / アカウントの管理";
      } else if (this.$route.path == "/myAccount") {
        return " / マイアカウント";
      } else if (this.$route.path == "/points") {
        return " <span>/ <a href='/myAccount' style='text-decoration:none;color:#fff;'>マイアカウント</a>/ ポイント履歴</span>";
      } else {
        return "";
      }
    },
    onClickBlank() {
      location.href = "/faq";
    },
    onClickMyAccount() {
      location.href = "/myAccount";
    },
    onClickMyAccountMannage() {
      location.href = "/accounts/manage";
    },
    onClickMyCart() {
      location.href = "/cart";
    },
    // pop up need register
    onClickCloseNeedRegister() {
      this.isRegisterMessage = false
    },
    onClickToRegisterPage() {
       location.href = "/init_register";
    },
  },
  beforeMount() {
    document.removeEventListener("message", (event) =>
      this.postMessageEventPopup(event)
    );
  },
};
</script>

<style scoped lang="scss">
@use "../assets/css/settings" as *;
@use "../assets/css/reset";
@import "../assets/css/base.css";

.content {
  width: 60vw;
  position: relative;
  height: 70vh;
  overflow: auto;
  background-color: #fff;
  padding: 1rem;
  border-radius: 0.5rem;
  color: black;

  a {
    color: #0d6efd;
    text-decoration: underline;
  }
  
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  .section {
    padding: 10px 10px;
    border-radius: 8px;
    margin-bottom: 2rem;

    background-color: #95c41c4d;
    .font-bold {
      font-size: 1.3rem;
      font-weight: bold;
    }
  }

  .footers {
    display: flex;
    justify-content: flex-end;
    height: 10%;
    align-items: center;
    .button {
      &:disabled {
        background-color: #c4c4c4;
      }
      background: #95c41c;
      padding: 0.5rem 2rem;
      border-radius: 0.5rem;
      font-weight: bold;
      color: #fff;
      cursor: pointer;
    }
  }
}

.serif-text {
  font-family: 'Meiryo,Yu Gothic,Avenir,Helvetica,Arial,sans-serif';
}

:root {
  font-size: calc(100px / $pcDesignRate);

  @include pcNarrow {
    font-size: calc(100vw * 100 / $pcDesignRate / $pcWidth);
  }

  @include sp {
    font-size: calc(100vw * 100 / $spDesignWidth);
  }
}

.menu-phone {
  padding: 2px 3px;
}

.body-header {
  color: #fff;
  font-family: $sans;
  font-size: $baseFontSize;
  font-optical-sizing: auto;
  font-weight: 700;
  letter-spacing: calc(0.02rem * 4);
  line-height: $baseLineHeight;
  overflow: auto;
  height: 60px;

  @include sp {
    font-size: $baseFontSizeSp;
    line-height: $baseLineHeightSp;
  }
}

.gHeader {
  background: #151515;
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
  transition: background-color 0.4s;
  //zoom: 4;

  @include sp {
    align-items: center;
    height: calc(1.58rem * 4);
    // height: calc(1.58rem * 4);
  }

  &::before {
    content: "";
    display: block;
    width: calc(4.84rem * 4);
    height: calc(0.9rem * 4);
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #a3c436, #75888a);
    clip-path: polygon(0 0, 100% 0, calc(100% - (0.64rem * 4)) 100%, 0 100%);
    opacity: 0;
    transition: opacity 0.4s;

    @include sp {
      content: none;
    }
  }

  .body-header.turnHeader &,
  .body-header.login & {
    align-items: center;
    height: calc(0.9rem * 4);
    background: #191919;

    @include sp {
      // height: calc(0.9rem * 4);
      height: calc(0.9rem * 4);
    }

    &::before {
      opacity: 1;
    }
  }

  // #common
  // #############################################################################################
  .btn {
    &--01 {
      overflow: hidden;
      background-image: linear-gradient(90deg, #a3c436, #75888a, #a3c436);
      background-position: 0 0;
      background-size: 200% 100%;
      background-repeat: no-repeat;

      @include hover {
        transition: background-position 0.4s;

        &:hover {
          background-position: 100% 0;
        }
      }
    }
  }

  // branding
  // ==========================================================================
  .branding {
    box-sizing: border-box;
    width: calc(1.95rem * 4);
    padding: calc(0.5rem * 4) 0 0 calc(0.5rem * 4);
    position: relative;
    z-index: +1;
    font-size: 1px;
    line-height: 1;
    transition: padding 0.4s;

    @include sp {
      padding: 0 0 0 calc(0.5rem * 4);
    }

    .body-header.turnHeader &,
    .body-header.login & {
      padding: 0 0 0 calc(0.5rem * 4);
    }
  }

  // navigation
  // ==========================================================================
  $barHeight: calc(0.03rem * 4);
  .gNav {
    $barBoxWidth: calc(0.24rem * 4);
    $barBoxHeight: calc(0.22rem * 4);
    $barColor: #fff;

    @include sp {
      display: flex;
      align-items: center;
      gap: calc(0.2rem * 4);
      padding: 0 calc(0.4rem * 4) 0 0;
    }

    .btn--menu {
      display: grid;
      place-items: center;
      width: calc(0.78rem * 4);
      height: calc(0.78rem * 4);
      position: relative;
      z-index: +1;
      border-radius: 50%;
      box-shadow: inset 0 0 0 calc(0.02rem * 4) #fff;

      @include pc {
        display: none;
      }

      input,
      .bar {
        grid-area: 1/1;
      }

      input {
        visibility: hidden;
      }

      .bar {
        display: grid;
        width: $barBoxWidth;
        height: $barBoxHeight;
        background-image: linear-gradient($barColor, $barColor);
        background-position: 50% 50%;
        background-size: 100% $barHeight;
        background-repeat: no-repeat;
        transition: background-size 0.2s;

        &::before,
        &::after {
          content: "";
          display: block;
          height: $barHeight;
          grid-area: 1/1;
          align-self: center;
          justify-self: stretch;
          background: $barColor;
          transition: transform 0.2s;
        }

        &::before {
          transform: translate3D(
            0,
            calc(#{calc($barBoxHeight / -2)} + #{calc($barHeight / 2)}),
            0
          );
        }

        &::after {
          transform: translate3D(
            0,
            calc(#{calc($barBoxHeight / 2)} - #{calc($barHeight / 2)}),
            0
          );
        }
      }
    }

    /* &:has(.btn--menu input:checked) {
      .btn--menu {
        .bar {
          background-size: 0 $barHeight;

          &::before {
            transform: translate3D(0, 0, 0) rotate(135deg);
          }

          &::after {
            transform: translate3D(0, 0, 0) rotate(45deg);
          }
        }
      }

      .navigation {
        .spMenu {
          translate: 0 0 0;
        }
      }
    } */

    // ==========================================================================
    .navigation {
      padding: calc(0.46rem * 4) calc(0.5rem * 4) 0 0;
      transition: padding 0.4s;

      @include sp {
        padding: 0;
      }

      .list {
        display: flex;

        @include sp {
          gap: calc(0.16rem * 4);
        }

        li {
          margin: 0 0 0 calc(0.2rem * 4);

          @include sp {
            margin: 0;
          }

          &:nth-child(-n + 3) {
            margin: 0 0 0 calc(0.3rem * 4);

            @include sp {
              margin: 0;
            }
          }
        }

        a {
          display: flex;
          align-items: center;
          justify-content: center;
          height: calc(0.52rem * 4);
          font-size: calc(0.16rem * 4);
          letter-spacing: calc(0.02rem * 4);
          line-height: 1;

          @include sp {
            height: calc(0.62rem * 4);
            font-size: calc(0.2rem * 4);
          }

          i {
            display: block;
            background: 0 0 / contain no-repeat;

            @include sp {
              display: none;
            }
          }
        }

        .guide {
          gap: calc(0.14rem * 4);

          @include sp {
            display: none;
          }

          i {
            width: calc(0.18rem * 4);
            height: calc(0.18rem * 4);
            background-image: url(../assets/img/ico-guide.svg);
            background-image: url(../assets/img/ico-guide.svg);
          }
        }

        .faq {
          gap: calc(0.1rem * 4);

          @include sp {
            display: none;
          }

          i {
            width: calc(0.2rem * 4);
            height: calc(0.2rem * 4);
            background-image: url(../assets/img/ico-faq.svg);
          }
        }

        .map {
          gap: calc(0.12rem * 4);
          box-sizing: border-box;
          width: calc(2.14rem * 4);
          padding: 0 calc(0.1rem * 4) 0 0;
          border-radius: calc(0.26rem * 4);
          box-shadow: inset 0 0 0 0.4px #fff;

          @include sp {
            display: none;
          }

          i {
            width: calc(0.15rem * 4);
            height: calc(0.2rem * 4);
            background-image: url(../assets/img/ico-map.svg);
          }
        }

        .entry,
        .status {
          gap: calc(0.12rem * 4);
          box-sizing: border-box;
          border-radius: calc(0.26rem * 4);
          box-shadow: inset 0 0 0 0.4px #fff;

          @include sp {
            width: calc(1.64rem * 4);
            padding: 0;
            border-radius: calc(0.61rem * 4);
          }

          i {
            width: calc(0.1rem * 4);
            height: calc(0.1rem * 4);
            background: #a3c436;
            border-radius: 50%;
          }
        }

        .entry {
          width: calc(2.14rem * 4);
          padding: 0 0.1rem 0 0;

          @include sp {
            width: calc(1.64rem * 4);
            padding: 0;
          }
        }

        .status {
          width: calc(2.3rem * 4);

          @include sp {
            display: none;
          }
        }

        .cart {
          display: block;
          width: calc(0.33rem * 4);
          background: url(../assets/img/ico-cart.svg) 0 50% / 100% auto
            no-repeat;
          position: relative;
          z-index: +1;
        }

        .login {
          display: grid;
          place-items: center;
          width: calc(1.44rem * 4);
          border-radius: calc(0.26rem * 4);

          @include sp {
            width: calc(1.24rem * 4);
            border-radius: calc(0.32rem * 4);
          }
        }
      }

      .spMenu {
        display: none;

        @include sp {
          display: block;
          box-sizing: border-box;
          width: calc(100vw);
          height: 100vh;
          padding: calc(1.66rem * 4) calc(0.75rem * 4) calc(0.75rem * 4);
          position: absolute;
          text-align: left;
          top: 0;
          left: 0;
          background: #151515;
          overflow-y: scroll;
          translate: 100% 0 0;
          transition: translate 0.4s;

          .toc {
            color: white;
            a {
              display: block;
              font-size: calc(0.24rem * 4);
              line-height: calc(96 / 30);
              padding: 0 0 0 calc(1.38rem * 4);

              &.map {
                background: url(../assets/img/ico-map.svg) calc(0.82rem * 4) 50% /
                  calc(0.25rem * 4) auto no-repeat;
              }

              &.guide {
                background: url(../assets/img/ico-guide2.svg) calc(0.73rem * 4)
                  50% / calc(0.43rem * 4) auto no-repeat;
              }

              &.faq {
                background: url(../assets/img/ico-faq2.svg) calc(0.77rem * 4)
                  50% / calc(0.35rem * 4) auto no-repeat;
              }

              &.contact {
                background: url(../assets/img/ico-contact.svg) calc(0.76rem * 4)
                  50% / calc(0.37rem * 4) auto no-repeat;
              }

              .body-header.login & {
                padding: 0 0 0 calc(0.94rem * 4);

                &.map {
                  background-position: calc(0.37rem * 4) 50%;
                }

                &.status {
                  background: url(../assets/img/ico-status.svg)
                    calc(0.33rem * 4) 50% / calc(0.34rem * 4) auto no-repeat;
                }

                &.myacount {
                  background: url(../assets/img/ico-myacount.svg)
                    calc(0.3rem * 4) 50% / calc(0.4rem * 4) auto no-repeat;
                }

                &.guide {
                  background-position: calc(0.28rem * 4) 50%;
                }

                &.faq {
                  background-position: calc(0.32rem * 4) 50%;
                }

                &.contact {
                  background-position: calc(0.31rem * 4) 50%;
                }

                &.all {
                  background: url(../assets/img/ico-all.svg) calc(0.35rem * 4)
                    50% / calc(0.29rem * 4) auto no-repeat;
                }
              }
            }
          }

          .member {
            margin: calc(0.62rem * 4) 0 0;

            // li {
            //   // margin: 0.28rem 0 0;
            // }

            a {
              display: grid;
              place-items: center;
              height: calc(0.92rem * 4);
              border-radius: calc(0.46rem * 4);
              font-size: calc(0.24rem * 4);

              &.entry {
                box-shadow: inset 0 0 0 calc(0.02rem * 4) #fff;
              }
            }
          }
        }
      }

      // ==========================================================================

      .body-header.turnHeader & {
        padding: 0 calc(0.5rem * 4) rem 0 0;

        @include sp {
          padding: 0;
        }
      }

      .body-header.login & {
        display: flex;
        align-items: center;
        gap: calc(0.2rem * 4);
        padding: 0 calc(0.5rem * 4) 0 0;

        @include sp {
          padding: 0;
        }

        .service {
          width: calc(2.55rem * 4);
          position: relative;

          @include sp {
            display: none;
          }

          .button {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: calc(0.08rem * 4);
            text-align: left;
            height: calc(0.52rem * 4);
            cursor: pointer;
            &:hover {
              color: #fff;
            }
          }

          .name {
            font-size: calc(0.16rem * 4);
            font-weight: 400;
            line-height: 1;
          }

          .label {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: calc(0.22rem * 4);
            line-height: 1;

            &::after {
              content: "";
              display: block;
              width: calc(0.31rem * 4);
              height: calc(0.31rem * 4);
              background: url(../assets/img/arw3.svg) 50% 50% / calc(0.1rem * 4)
                auto no-repeat;
              border-radius: 50%;
              box-shadow: inset 0 0 0 0.4px #fff;
            }
          }

          .menu {
            display: none;
            width: 100%;
            padding: calc(0.24rem * 4) 0 0;
            position: absolute;
            top: 100%;
            text-align: left;
            left: 0;

            ul {
              padding: calc(0.2rem * 4) 0 calc(0.2rem * 4) calc(0.3rem * 4);
              background: #fff;
              border-radius: calc(0.1rem * 4);
              color: #000;
              font-size: calc(0.16rem * 4);
              font-weight: 400;
              line-height: calc(36 / 16);
            }

            @include hover {
              a:hover {
                color: #a3c436;
                font-weight: 700;
              }
            }
          }
          
          .menu-ghost {
            display: block;
            width: 100%;
            padding: 0.24rem 0 0;
            position: absolute;
            top: 100%;
            left: 0;
          }
        }
      }
    }
  }
  .transform-menu {
    .btn--menu {
      .bar {
        background-size: 0 $barHeight;

        &::before {
          transform: translate3D(0, 0, 0) rotate(135deg);
        }

        &::after {
          transform: translate3D(0, 0, 0) rotate(45deg);
        }
      }
    }

    .navigation {
      .spMenu {
        translate: 0 0 0;
      }
    }
  }
}

@media print {
  .body-header {
    zoom: 0.5;

    .gHeader {
      position: absolute;
    }
  }
}

a:hover {
  cursor: pointer;
}

/* .show-navbar {
  animation-name: slideLeft;
  animation-duration: 0.4s;
}

.hide-navbar {
  animation-name: slideRight;
  animation-duration: 0.4s;
}
*/

@keyframes slideLeft {
  from {
    translate: 100% 0 0;
  }
  to {
    translate: 0 0 0;
  }
}

@keyframes slideRight {
  from {
    translate: 0 0 0;
  }
  to {
    translate: 100% 0 0;
  }
}
.font-popup-apartment {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 24px;
}
.font-red-popup {
  color: #9F1800;
}
.red-background-popup {
  background-color: #9F1800;
}
.flex-popup-apartment {
  display: flex;
  flex-direction: column;
  justify-content: left;
  text-align: left;
  gap: 4px;
}
</style>
